var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCriticalRisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.717 7.045L6.433 1.183C6.137.655 5.59.33 4.998.33c-.592 0-1.138.325-1.434.853L.222 7.146c-.296.528-.296 1.178 0 1.706s.843.853 1.434.853h6.688c.914 0 1.656-.764 1.656-1.706 0-.353-.105-.682-.283-.954zm-4.01.57c0 .404-.301.713-.707.713-.406 0-.707-.309-.707-.712v-.017c0-.401.301-.712.707-.712.406 0 .707.309.707.712v.017zm.017-4.798l-.35 3.148c-.024.227-.17.368-.374.368s-.35-.143-.374-.368l-.35-3.15c-.023-.243.105-.427.325-.427h.796c.22.001.35.185.327.429z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalRisk);
export default __webpack_public_path__ + "static/media/critical-risk.c8ee862bc4c35e02eb1663ff113d9c33.svg";
export { ForwardRef as ReactComponent };